import { render, staticRenderFns } from "./FoodsStatistic.vue?vue&type=template&id=414bd1aa&scoped=true&"
import script from "./FoodsStatistic.vue?vue&type=script&lang=js&"
export * from "./FoodsStatistic.vue?vue&type=script&lang=js&"
import style0 from "./FoodsStatistic.vue?vue&type=style&index=0&id=414bd1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414bd1aa",
  null
  
)

export default component.exports